import { toConsumableArray as _toConsumableArray, slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useMemo, useRef } from 'react';
import useCallbackRef from './use-callback-ref.esm.js';
import useControllableState from './use-controllable.esm.js';

var SELECT_ALL_KEY = ['SELECT_ALL', '-1', '0'];
function useSelectState (selection, initialSelection, onChange) {
  var isMultiSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var mutuallyExclusiveGroups = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var optionKeys = arguments.length > 5 ? arguments[5] : undefined;
  var onChangeProp = useCallbackRef(onChange);
  var availableOptionKeys = useMemo(function () {
    return isMultiSelect && Array.isArray(optionKeys) ? _toConsumableArray(optionKeys.filter(function (i) {
      return !SELECT_ALL_KEY.includes(i);
    })) : [];
  }, [isMultiSelect, optionKeys]);
  var internalSelection = useRef(Array.isArray(initialSelection) && availableOptionKeys.length > 0 && initialSelection.length === availableOptionKeys.length);
  var _useControllableState = _slicedToArray(useControllableState({
      value: selection,
      defaultValue: Array.isArray(initialSelection) ? isMultiSelect ? initialSelection : initialSelection[0] : initialSelection ? isMultiSelect ? [initialSelection] : initialSelection : undefined,
      onChange: onChangeProp
    }).state, 2),
    value = _useControllableState[0],
    setValue = _useControllableState[1];
  var handler = function handler(selectionKey) {
    return function () {
      if (isMultiSelect) {
        var curValue = Array.isArray(value) ? value : value ? [value] : [];
        var nextValue = [];
        if (typeof selectionKey === 'string' && SELECT_ALL_KEY.includes(selectionKey)) {
          if (!internalSelection.current || curValue.length !== availableOptionKeys.length) {
            nextValue = _toConsumableArray(availableOptionKeys);
          }
        } else {
          if (mutuallyExclusiveGroups && typeof selectionKey === 'string' && selectionKey.includes('.')) {
            if (curValue.includes(selectionKey)) {
              nextValue = curValue.filter(function (i) {
                return i !== selectionKey;
              });
            } else {
              var groupKey = selectionKey.slice(0, selectionKey.indexOf('.'));
              if (curValue.some(function (i) {
                return typeof i === 'string' && i.includes("".concat(groupKey, "."));
              })) {
                nextValue = [].concat(_toConsumableArray(curValue), [selectionKey]);
              } else {
                nextValue = [selectionKey];
              }
            }
          } else {
            if (curValue.includes(selectionKey)) {
              nextValue = curValue.filter(function (i) {
                return i !== selectionKey;
              });
            } else {
              nextValue = [].concat(_toConsumableArray(curValue), [selectionKey]);
            }
          }
        }
        setValue(nextValue);
        internalSelection.current = availableOptionKeys.length > 0 && nextValue.length === availableOptionKeys.length;
      } else {
        setValue(selectionKey);
      }
    };
  };
  return {
    value: value,
    handler: handler,
    allSelected: internalSelection.current
  };
}

export default useSelectState;
//# sourceMappingURL=use-select-state.esm.js.map
